import React from 'react';
import PropTypes from 'prop-types';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Popover from 'material-ui/Popover';
import { FormattedMessage } from 'react-intl';

import browserLanguage from 'lib/browserLanguage';

class LanguageSelector extends React.Component {
  static propTypes = {
    lang: PropTypes.string,
    changeLanguage: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      anchorEl: null,
    };
  }

  handleTouchTap = ev => {
    ev.preventDefault();
    this.setState({
      open: true,
      anchorEl: ev.currentTarget,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
      anchorEl: null,
    });
  };

  handleSelect = lang => () => {
    this.setState({ open: false, anchorEl: null });
    this.props.changeLanguage(lang);
  };

  render() {
    const lang = this.props.lang || browserLanguage;

    return (
      <React.Fragment>
        <span onClick={this.handleTouchTap}>
          <FormattedMessage
            id={`languages.${lang.toLowerCase() /* Language appreviation might be saved in uppercase */}`}
          />
        </span>
        <Popover open={this.state.open} anchorEl={this.state.anchorEl} onRequestClose={this.handleClose}>
          <Menu>
            <MenuItem onClick={this.handleSelect('fi')}>
              <FormattedMessage id="languages.fi" />
            </MenuItem>
            <MenuItem onClick={this.handleSelect('sv')}>
              <FormattedMessage id="languages.sv" />
            </MenuItem>
            <MenuItem onClick={this.handleSelect('en')}>
              <FormattedMessage id="languages.en" />
            </MenuItem>
          </Menu>
        </Popover>
      </React.Fragment>
    );
  }
}

export default LanguageSelector;
